import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import {
  actionTypes,
  getApplicationPropertiesFailure,
  getApplicationPropertiesSuccess,
  getApplicationsFailure,
  getApplicationsSuccess,
  getBaoFailure,
  getBaoSuccess,
  getChainEntitlementsFailure,
  getChainEntitlementsSuccess,
  getEntitlementCustomPropertiesFailure,
  getEntitlementCustomPropertiesSuccess,
  getEntitlementsFailure,
  getEntitlementsSuccess,
  getStepFiveEntitlementsFailure,
  getStepFiveEntitlementsSuccess,
  updateChainEntitlementsFailure,
  updateChainEntitlementsSuccess,
  updateEntitlementPropertiesFailure,
  updateEntitlementPropertiesSuccess,
  updatePropertiesFailure,
  updatePropertiesSuccess,
} from "./actions";
import {
  fetchApplicationPropertiesRequest,
  fetchApplicationsRequest,
  fetchChainEntitlementsRequest,
  fetchEntitlementCustomPropertiesRequest,
  fetchEntitlementsRequest,
  fetchGetBao,
  updateChainEntitlementsRequest,
  updateEntitlementPropertiesRequest,
  updatePropertiesRequest,
} from "./services";

const fetchGetBaoEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_BAO),
    mergeMap((action: any) =>
      fetchGetBao(action.payload).pipe(
        map((response: any) => getBaoSuccess(response)),
        catchError((error: any) => of(getBaoFailure(error)))
      )
    )
  );

const fetchApplicationRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_APPLICATIONS_MGMT_REQUEST),
    mergeMap((action: any) =>
      fetchApplicationsRequest(action.payload).pipe(
        map((response: any) => getApplicationsSuccess(response)),
        catchError((error: any) => of(getApplicationsFailure(error)))
      )
    )
  );

const fetchApplicationPropertiesRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_APPLICATION_PROPERTIES),
    mergeMap((action: any) =>
      fetchApplicationPropertiesRequest(action.payload).pipe(
        map((response: any) => getApplicationPropertiesSuccess(response)),
        catchError((error: any) => of(getApplicationPropertiesFailure(error)))
      )
    )
  );

const updatePropertiesRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_APPLICATION_PROPERTIES),
    mergeMap((action: any) =>
      updatePropertiesRequest(action.payload).pipe(
        map((response: any) => updatePropertiesSuccess(response)),
        catchError((error: any) => of(updatePropertiesFailure(error)))
      )
    )
  );

const fetchEntitlementsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_ENTITLEMENTS_MGMT_REQUEST),
    mergeMap((action: any) =>
      fetchEntitlementsRequest(action.payload).pipe(
        map((response: any) => getEntitlementsSuccess(response)),
        catchError((error: any) => of(getEntitlementsFailure(error)))
      )
    )
  );

const fetchEntitlementCustomPropertiesRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_ENTITLEMENT_PROPERTIES),
    mergeMap((action: any) =>
      fetchEntitlementCustomPropertiesRequest(action.payload).pipe(
        map((response: any) => getEntitlementCustomPropertiesSuccess(response)),
        catchError((error: any) =>
          of(getEntitlementCustomPropertiesFailure(error))
        )
      )
    )
  );

const updateEntitlementPropertiesRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_ENTITLEMENT_PROPERTIES),
    mergeMap((action: any) =>
      updateEntitlementPropertiesRequest(action.payload).pipe(
        map((response: any) => updateEntitlementPropertiesSuccess(response)),
        catchError((error: any) =>
          of(updateEntitlementPropertiesFailure(error))
        )
      )
    )
  );

const fetchEntitlementsStepFiveRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_STEP_FIVE_ENTITLEMENTS_MGMT_REQUEST),
    mergeMap((action: any) =>
      fetchEntitlementsRequest(action.payload).pipe(
        map((response: any) => getStepFiveEntitlementsSuccess(response)),
        catchError((error: any) => of(getStepFiveEntitlementsFailure(error)))
      )
    )
  );

const fetchChainEntitlementsStepFiveRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FETCH_CHAIN_ENTITLEMENTS_MGMT_REQUEST),
    mergeMap((action: any) =>
      fetchChainEntitlementsRequest(action.payload).pipe(
        map((response: any) => getChainEntitlementsSuccess(response)),
        catchError((error: any) => of(getChainEntitlementsFailure(error)))
      )
    )
  );

const updateChainEntitlementsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_CHAIN_ENTITLEMENT_REQUEST),
    mergeMap((action: any) =>
      updateChainEntitlementsRequest(action.payload).pipe(
        map((response: any) => updateChainEntitlementsSuccess(response)),
        catchError((error: any) => of(updateChainEntitlementsFailure(error)))
      )
    )
  );

export default [
  fetchGetBaoEpic,
  fetchApplicationRequestEpic,
  fetchApplicationPropertiesRequestEpic,
  updatePropertiesRequestEpic,
  fetchEntitlementsRequestEpic,
  fetchEntitlementCustomPropertiesRequestEpic,
  fetchEntitlementsStepFiveRequestEpic,
  fetchChainEntitlementsStepFiveRequestEpic,
  updateEntitlementPropertiesRequestEpic,
  updateChainEntitlementsRequestEpic,
];
